import Layout from "components/structure/Layout";
import React, { useCallback } from "react";
import AccessTable from "../Common/AccessTable";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import Delegation from "assets/delegation.svg";
import AddButton from "assets/add.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import RoleService from "services/RoleService";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { AuthData } from "auth/AuthWarpper";
import { useTranslation } from "react-i18next";
import CustomPagination from "components/pages/Import/Common/CustomPagination";

const RoleCreation = () => {

  const { t, i18n } = useTranslation()
  const navigate = useNavigate();
  const { user } = AuthData();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [data, setData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const fetchData = async (page = 0, pageSize = itemsPerPage) => {
    setLoading(true);
    try {
      
      const response = await RoleService.getRole(page, pageSize);
      
      const responseData = response.data.response?.roles;
      setTotalItems(response.data.response?.totalItems);


      const rows = responseData?.map((item) => ({
        profileId: item.profileId,
        profileCode: item.profileCode,
        profileName: item.profileName,
        isActive: item.isActive === true ? "Active" : "Inactive",
        profileAttribute: item.profileAttribute,
        isDeleted: item.isDeleted,
        createdByUser: item.createdByUser,
        modifiedDateTimeUTC: item.modifiedDateTimeUTC,
        modifiedByUser: item.modifiedByUser,
        profileOwnerId: item.profileOwnerId,
        profileOwnerName: item.profileOwnerName,
        roleFunctionality: item.functionalities ? item?.functionalities?.map((ele) => ele?.functionality_name).join(', ') : '',
        functionalities: item.functionalities,
        serviceNumber: item.serviceNumber,
        remarks: item.remarks,
        countries: item.countries ? item.countries?.map((ele) => ele?.countryName).join(', ') : "",
        countriesList: item.countries,
          assignmentStatus: item.assignmentStatus,

      }));
      setData(rows);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);



  const handleSearch = useCallback(
    debounce(async (query) => {
      setCurrentPage(0);
      
      // If query length is 0 or only contains spaces, fetch all data
      if (!query.trim()) {
        fetchData(0, itemsPerPage);
        return;
      }

      // Only search if there's a valid query
      if (query.length >= 1) {
      setLoading(true);
      try {
        const response = await RoleService.searchRole(query, 0, itemsPerPage);
        const responseData = response.data.response?.roles;
        setTotalItems(response.data.response?.totalItems);

        const rows = responseData?.map((item) => ({
          profileId: item.profileId,
          profileCode: item.profileCode,
          profileName: item.profileName,
          isActive: item.isActive === true ? "Active" : "Inactive",
          profileAttribute: item.profileAttribute,
          isDeleted: item.isDeleted,
          assignmentStatus: item.assignmentStatus,
          createdByUser: item.createdByUser,
          modifiedDateTimeUTC: item.modifiedDateTimeUTC,
          modifiedByUser: item.modifiedByUser,
          profileOwnerId: item.profileOwnerId,
          profileOwnerName: item.profileOwnerName,
          roleFunctionality: item.functionalities ? item?.functionalities?.map((ele) => ele?.functionality_name).join(', ') : '',
          functionalities: item.functionalities,
          serviceNumber: item.serviceNumber,
          remarks: item.remarks,
          countries: item.countries ? item.countries?.map((ele) => ele?.countryName)?.join(', ') : "",
          countriesList: item.countries,
          assignmentStatus: item.assignmentStatus,
        }));
        setData(rows);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setSeverity("error");
        setMessage("No Record Found");
        setOpenAlert(true);
        setData([]);
      } finally {
        setLoading(false);
      }
    }
  }, 500),
  []
);

  const searchData = async (query, page, pageSize) => {
    setLoading(true);
    try {
      const response = await RoleService.searchRole(query, page, pageSize);
      const responseData = response.data.response?.roles;
      setTotalItems(response.data.response?.totalItems);

      const rows = responseData?.map((item) => ({
        profileId: item.profileId,
        profileCode: item.profileCode,
        profileName: item.profileName,
        isActive: item.isActive === true ? "Active" : "Inactive",
        profileAttribute: item.profileAttribute,
        isDeleted: item.isDeleted,
        assignmentStatus: item.assignmentStatus,
        createdByUser: item.createdByUser,
        modifiedDateTimeUTC: item.modifiedDateTimeUTC,
        modifiedByUser: item.modifiedByUser,
        profileOwnerId: item.profileOwnerId,
        profileOwnerName: item.profileOwnerName,
        roleFunctionality: item.functionalities ? item?.functionalities?.map((ele) => ele?.functionality_name).join(', ') : '',
        functionalities: item.functionalities,
        serviceNumber: item.serviceNumber,
        remarks: item.remarks,
        countries: item.countries ? item.countries?.map((ele) => ele?.countryName)?.join(', ') : "",
        countriesList: item.countries,
        assignmentStatus: item.assignmentStatus,
      }));
      setData(rows);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
        setMessage("No Record Found");
      setOpenAlert(true);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (searchQuery.trim()) {
      searchData(searchQuery.trim(), newPage, itemsPerPage);
    } else {
      fetchData(newPage, itemsPerPage);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setItemsPerPage(newPageSize);
    setCurrentPage(0);
    if (searchQuery.trim()) {
      searchData(searchQuery.trim(), 0, newPageSize);
    } else {
      fetchData(0, newPageSize);
    }
  };

  const columns = [
    { label: t("administratorAccess.roleName"), field: "profileName", align: "left" },
    { label: t("userCreation.country"), field: "countries", align: "left" },
    { label: t("administratorAccess.attribute"), field: "profileAttribute", align: "left" },
    { label: t("administratorAccess.profileOwnerName"), field: "profileOwnerName", align: "left" },
    { label: t("administratorAccess.roleFunctionality"), field: "roleFunctionality", align: "left" },
    { label: t("Functionality Assignment Status"), field: "assignmentStatus", width:"300px", align: "left" },
    { label: t("Role Status"), field: "isActive", align: "left" ,width:"100px"},
    { label: t("Action"), field: "action", align: "left" },
  ];

  const handleDelegation = () => {
    const batOneId = user?.batOneId;
    RoleService.fetchDelegation(batOneId)
      .then((res) => {
        // navigate("/Delegationupdate", { state: { rowData: { data: res?.data?.response, fromUrl: "RoleCreation" } } })
        navigate("/ownAndOthersDelegation", { state: { fromUrl: "roleCreation" } })

      })
      .catch((error) => {
        console.error("API call failed:", error);
        navigate("/ownAndOthersDelegation", { state: { fromUrl: "roleCreation" } })

      })
  };

  const paginate = (pageNumber, newItemsPerPage) => {
    setCurrentPage(pageNumber - 1);
    setItemsPerPage(newItemsPerPage);
    if (searchQuery.trim()) {
      searchData(searchQuery.trim(), pageNumber - 1, newItemsPerPage);
    } else {
      fetchData(pageNumber - 1, newItemsPerPage);
    }
  };

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "75px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box>
              <TextField
                sx={{ width: "403px" }}
                fullWidth
                value={searchQuery}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchQuery(value);
                  handleSearch(value);
                }}
                placeholder={t("search")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                // variant="outlined"
                  sx={{
                  pt: '6px',
                  pr: '15px',
                  pb: '6px',
                  pl: '15px',
                  background: '#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: '0.739px solid #FFF',
                  color: '#0A3575',
                  fontSize: '20.696px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  fontWeight: '500',
                }}
                startIcon={<img src={Delegation} alt="delegation" />}
                onClick={() => navigate('/otherDelegation', { state: { fromUrl: "roleCreation" } })}
              //roleDelegation
              >
                {t("delegation")}

              </Button>
              <Button
                // variant="outlined"
                onClick={() => navigate("/addRoleCreation")}
                 sx={{
                  pt: '6px',
                  pr: '15px',
                  pb: '6px',
                  pl: '15px',
                  background: '#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: '0.739px solid #FFF',
                  color: '#0A3575',
                  fontSize: '20.696px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  fontWeight: '500',
                }}
                startIcon={<img src={AddButton} alt="add" />}
              >
                {t("addNewRole")}
              </Button>
            </Box>
          </Box>

          <AccessTable
            columns={columns}
            rows={data}
            url={"/editRoleCreation"}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              mb: 2,
            }}
          >
            <Button
              sx={{
                borderRadius: 2,
                background: "#EF7D00",
                color: "#ffffff",
                fontWeight: 600,
                height: 54,
                width: { xs: "100%", md: "156px" },
                "&:hover": {
                  backgroundColor: "#EF7D00",
                },
              }}
              onClick={() => navigate("/export", { state: 'role',profileInfo:user?.userAttribute , extractType:'role'})}
            >
              {t("export")}
            </Button>
          </Box>
        </Box>
        {data?.length > 0 &&
            <div style={{ position: "absolute", width: "calc(100% - 1px)", marginLeft:"-24px", bottom: "0px" }}>
              {data &&
                <CustomPagination
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={(v) => setItemsPerPage(v)}
                  totalItems={totalItems}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              }
            </div>
          }
      </Box>
    </LayoutAccessManagement>
  );
};

export default RoleCreation;
